const GENERIC_SUGGESTIONS = [
  "Wishing you all the best! You deserve it",
  "Cheers to you! Here's to many more",
  "So proud of you! Keep shining",
  "Thinking of you and sending warm wishes",
  "Sending you love and good vibes",
  "Celebrating you today — you're the best",
];

const OCCASION_SUGGESTIONS: Record<string, string[]> = {
  birthday: [
    "Happy birthday! Wishing you an amazing year ahead",
    "Another year, another reason to celebrate you",
    "Hope your day is as wonderful as you are",
    "Wishing you cake, laughter, and everything you love",
    "Many happy returns — you deserve all the joy today",
  ],
  farewell: [
    "Wishing you the very best on your next chapter",
    "Thanks for everything — you'll be missed",
    "Onwards and upwards! Stay in touch",
    "It's been a pleasure working with you — good luck!",
    "So grateful for everything you've shared with us",
  ],
  baby: [
    "Congratulations on your little one! ",
    "Wishing your new family lots of love and sleep",
    "So happy for you — welcome, little one!",
    "Sending love to the newest addition",
    "Hugs for the new parents and tiny fingers to hold",
  ],
  wedding: [
    "Congratulations! Wishing you a lifetime of love",
    "Here's to a beautiful journey together",
    "So happy for you both — love always wins",
    "Wishing you joy, laughter, and forever adventures",
    "Cheers to the happy couple!",
  ],
  "thank-you": [
    "Thank you so much — it really meant a lot",
    "You're the best, truly appreciate you",
    "Words can't express how grateful I am",
    "Thanks for going above and beyond",
    "So thankful to have you in my corner",
  ],
  retirement: [
    "Congratulations on your retirement — enjoy every moment!",
    "Here's to the next adventure — you've earned it",
    "Wishing you rest, travel, and all the fun",
    "Thank you for everything — enjoy this well-deserved chapter",
    "Cheers to a lifetime of hard work — now relax!",
  ],
  "get-well": [
    "Sending healing thoughts your way",
    "Wishing you a speedy recovery",
    "Rest up — we're thinking of you",
    "Get well soon! We miss you",
    "Sending strength and all our love",
  ],
  sympathy: [
    "Thinking of you during this difficult time",
    "Sending love and strength your way",
    "We're so sorry for your loss",
    "Holding you close in our thoughts",
    "With deepest sympathy — we're here for you",
  ],
  graduation: [
    "Congratulations, grad! So proud of you",
    "You did it! The world is yours now",
    "Cheers to your hard work — this is only the beginning",
    "So excited to see what you do next",
    "All the best on your next adventure!",
  ],
  teacher: [
    "Thank you for making a difference",
    "You're an incredible teacher — we appreciate you",
    "Thanks for inspiring us every day",
    "The best teachers leave a mark forever — thank you",
    "Wishing you joy for everything you give",
  ],
  anniversary: [
    "Happy anniversary! Here's to many more",
    "Wishing you both continued love and laughter",
    "Still the sweetest couple — cheers to you",
    "So happy for you both today",
    "Another year of love — congratulations!",
  ],
  christmas: [
    "Merry Christmas! Wishing you joy and warmth",
    "Happy holidays — may your season be bright",
    "Sending love and Christmas cheer",
    "Warmest wishes this festive season",
    "Hope your holidays are full of love and laughter",
  ],
  valentines: [
    "Happy Valentine's Day! You're the best",
    "Sending you love today and always",
    "You make every day feel like Valentine's",
    "Thinking of you with love",
    "Lucky to have you — happy Valentine's!",
  ],
  congratulations: [
    "Congratulations! So happy for you",
    "You earned this — celebrating with you",
    "Huge congrats! Here's to many more wins",
    "So proud of everything you've achieved",
    "Cheers to you — well deserved!",
  ],
};

export function getQuickSuggestions(occasion?: string | null): string[] {
  if (!occasion) return GENERIC_SUGGESTIONS;
  return OCCASION_SUGGESTIONS[occasion] ?? GENERIC_SUGGESTIONS;
}
